import type { TailwindPattern } from "../interface";

const visibilityPattern: TailwindPattern = {
    base: /(in)?visible|collapse/,
};

export default visibilityPattern;

export const visibilitySample = [["visible", "invisible", "collapse"]];
